import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_summer_entertaining: FaireThemeEntity = {
  token: "discovery_theme_summer-entertaining",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Summer Entertaining",
  description: "Everything you need for outdoor gatherings",
  bgColor: "#FFF0D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
